<template>
    <b-row>
        <b-col md="12">
            <b-card>
                <warehouse-form
                    ref="warehouseForm"
                    submit-label="CREAR ALMACÉN"
                    :saving="saving"
                    @submit="createWarehouse"
                />
            </b-card>
        </b-col>
    </b-row>
</template>

<script>

    import { BRow, BCol, BCard } from 'bootstrap-vue';
    import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
    import Toast from 'vue-toastification';
    import axios from '@axios';
    import Vue from 'vue';

    import WarehouseForm from '../WarehouseForm.vue';

    Vue.use(Toast);

    export default {
        components: {
            BRow,
            BCol,
            BCard,
            WarehouseForm
        },
        data() {
            return {
                saving: false
            }
        },
        methods: {
            createWarehouse(data) {

                this.saving = true;

                axios.post('/warehouse/create', data)
                    .then(response => {

                        this.$toast({
                            component: ToastificationContent,
                            props: {
                                title: response.data.message,
                                icon: 'CheckIcon',
                                variant: 'success'
                            }
                        });

                        this.$refs.warehouseForm.reset();
                        this.$router.push({ name: 'warehouses' });

                    })
                    .catch(err => {

                        const message = err.response && err.response.data.message ?
                            err.response.data.message : 'Error al crear el almacén.';

                        this.$toast({
                            component: ToastificationContent,
                            props: {
                                title: message,
                                icon: 'AlertTriangleIcon',
                                variant: 'danger'
                            }
                        });

                    })
                    .finally(() => {
                        this.saving = false;
                    });
            }
        }
    }

</script>
